import moment from "moment";
moment.locale("ru");

function isToday(date) {
  const today = moment();
  return today.isSame(date, "day");
}

function isDayBefore(date) {
  const dayBefore = moment().subtract(1, "day");
  return dayBefore.isSame(date, "day");
}

function isTwoDayBefore(date) {
  const twoDayBefore = moment().subtract(2, "day");
  return twoDayBefore.isSame(date, "day");
}

export default function formatDate(date) {
  const d = moment(date);

  let s = "";

  if (isToday(d)) {
    s = "Сегодня";
  } else if (isDayBefore(d)) {
    s = "Вчера";
  } else if (isTwoDayBefore(d)) {
    s = "Позавчера";
  }

  if (s) {
    return `${s} (${d.format("HH:mm")})`;
  }

  return d.format("D MMM YYYY (H:mm)");
}
